import { render, staticRenderFns } from "./PalveluhakemusValtuutettu.vue?vue&type=template&id=258612fc&scoped=true&"
import script from "./PalveluhakemusValtuutettu.vue?vue&type=script&lang=js&"
export * from "./PalveluhakemusValtuutettu.vue?vue&type=script&lang=js&"
import style0 from "./PalveluhakemusValtuutettu.vue?vue&type=style&index=0&id=258612fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258612fc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('258612fc')) {
      api.createRecord('258612fc', component.options)
    } else {
      api.reload('258612fc', component.options)
    }
    module.hot.accept("./PalveluhakemusValtuutettu.vue?vue&type=template&id=258612fc&scoped=true&", function () {
      api.rerender('258612fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PalveluhakemusValtuutettu.vue"
export default component.exports